import React, {useState} from 'react';
import { Table, Divider} from "antd";
import {summaryColumnData} from'./columns';
import {getGridTableHeight, getAssetTypeTitle, amountFormatter, floatFormatter} from '../Common/util';


/** -------------------------------------------------------------------------- **/
function Summary({measureList, sumData}) {

    return (
        <>
            <div className="sub_title">
                    {'■ 부분별 진단 결과'}
            </div>
            <div style={{padding: '0px 10px'}}>
                <Table 
                        columns={summaryColumnData}
                        dataSource={measureList}
                        pagination={false}
                        rowKey='code'
                        bordered size={"small"}
                        className="sub_table"
                        summary={() => {
                            return (
                              <>
                                <Table.Summary.Row>
                                  <Table.Summary.Cell index={0} colSpan={2}>{'전체 보안 수준'}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={2}>{amountFormatter(sumData.total)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={3}>{amountFormatter(sumData.check)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={4}>{amountFormatter(sumData.Y)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={5}>{amountFormatter(sumData.N)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={5}>{amountFormatter(sumData.P)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={5}>{amountFormatter(sumData.NA)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={6}>{amountFormatter(sumData.total_score)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={7}>{amountFormatter(sumData.eval_score)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={8}>{floatFormatter(sumData.level,1)}%</Table.Summary.Cell>
                                </Table.Summary.Row>
                              </>
                            );
                        }}
                        >
                    </Table>
            </div>
        </>
    );
}
export default Summary;